// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface RelatedProductStyle {
    wrapper?: InjectableCss;
    headerWrapper?: InjectableCss;
    headerLeftSection?: InjectableCss;
    headerRightSection?: InjectableCss;
    rightSectionPrice?: InjectableCss;
    rightSectionQty?: InjectableCss;
    rightSectionTotal?: InjectableCss;
    headerText?: TypographyPresentationProps;
}

export const styles: RelatedProductStyle = {
    headerWrapper: {
        css: css`
            display: flex;
            align-items: center;
            padding: 10px 10px 8px;
            background: ${getColor("common.ui4")};
        `,
    },
    headerLeftSection: {
        css: css`
            flex-grow: 1;
            width: 100%;
            max-width: 620px;
        `,
    },
    headerRightSection: {
        css: css`
            display: flex;
            flex-grow: 1;
        `,
    },
    rightSectionPrice: {
        css: css`
            width: calc((100% - 60px) / 2);
            text-align: left;
            @media (max-width: 1023px) {
                display: none;
            }
        `,
    },
    rightSectionQty: {
        css: css`
            width: 60px;
            text-align: center;
            @media (max-width: 1023px) {
                display: none;
            }
        `,
    },
    rightSectionTotal: {
        css: css`
            width: calc((100% - 60px) / 2);
            text-align: right;
            @media (max-width: 1023px) {
                display: none;
            }
        `,
    },
    headerText: {
        size: "13px",
        lineHeight: "22px",
        transform: "uppercase",
        css: css`
            font-weight: 500;
        `,
    },
};

const LinesHeader = () => {
    return (
        <StyledWrapper {...styles.headerWrapper}>
            <StyledWrapper {...styles.headerLeftSection}>
                <Typography>{translate("Products")}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.headerRightSection}>
                <StyledWrapper {...styles.rightSectionPrice}>
                    <Typography {...styles.headerText}>{translate("Price/Unit")}</Typography>
                </StyledWrapper>
                <StyledWrapper {...styles.rightSectionQty}>
                    <Typography {...styles.headerText}>{translate("Qty")}</Typography>
                </StyledWrapper>
                <StyledWrapper {...styles.rightSectionTotal}>
                    <Typography {...styles.headerText}>{translate("Total")}</Typography>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default LinesHeader;
